export const depths = [16, 18, 20];
